import { AuthService } from "../services";
import { IMeeting } from "../types";

export const isCanEditMeeting = (meeting: IMeeting) => {
  const token = AuthService.getUserId();
  const roles = AuthService.getUserRoles();

  return (
    (meeting.initiator?.id === token || roles.includes("MODERATOR")) &&
    new Date().getTime() < meeting.startDate.getTime() &&
    meeting.calendarId === -1
  );
};

export const isEditByModerator = (meeting: IMeeting) => {
  const token = AuthService.getUserId();
  const roles = AuthService.getUserRoles();

  return (
    meeting.initiator?.id !== token && // редактирует чужой чел
    meeting.id !== null && // редактирует свою встречу
    roles.includes("MODERATOR") && // является модератором
    new Date().getTime() < meeting.startDate.getTime() && // время раньше старта
    meeting.calendarId === -1 // свой календарь
  );
};
